import { onError } from '@apollo/client/link/error'
import type { GraphQLFormattedError } from 'graphql'
import { isServerError } from 'api/error'
import { i18n } from 'i18n'
import { LOGOUT_PATH } from 'routes/paths'
import { getCookie } from 'utils/cookies'
import { sendMessageToApp } from 'utils/react-native-webview'

const UNAUTHENTICATED_MESSAGE = 'unauthenticated'
const ACCESS_TOKEN_COOKIE = 'access_token'

const hasUnauthenticatedError = (
  graphQLErrors: ReadonlyArray<GraphQLFormattedError> | undefined
): boolean =>
  Boolean(
    graphQLErrors?.some(({ message }) => message === UNAUTHENTICATED_MESSAGE)
  )

const hasStoredSession = (): boolean => Boolean(getCookie(ACCESS_TOKEN_COOKIE))

export const errorLink = onError(({ graphQLErrors, networkError }) => {
  const isDevMode = process.env.NODE_ENV === 'development'
  const logoutUser = () => {
    if (typeof window !== 'undefined' && window.ReactNativeWebView) {
      sendMessageToApp({ type: 'logout', data: { reason: 'session_expired' } })
      return
    }

    if (!hasStoredSession()) return

    global.alert(i18n.t('Sua sessão expirou, por favor faça login novamente.'))
    global.location.href = LOGOUT_PATH
  }

  const sessionRejected =
    (isServerError(networkError) && networkError.statusCode === 401) ||
    hasUnauthenticatedError(graphQLErrors)

  if (sessionRejected) {
    logoutUser()
  }

  if (isDevMode && graphQLErrors) {
    graphQLErrors.forEach(({ message, locations, path }) => {
      console.error(
        `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
      )
    })
  }

  if (isDevMode && networkError) {
    console.error(
      `[Network error]: Name: ${networkError.name}, Message: ${networkError.message}`
    )
  }
})
